module.exports = __webpack_public_path__ + "static/seconds-icon-rounded-small-c0c68f2c549316fc24f73d8ae432061b.png";